<template lang="pug">
div
  v-container.pa-8(fluid)
    div.d-flex.justify-center.mt-16(v-if="isFetching")
      v-progress-circular(:width="2" :size="50" color="primary" indeterminate)

    template(v-else-if="stockTake")
      v-row(no-gutters align="center")
        v-col(cols="6")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="openRevertCount" height)
                v-icon(color="basic800" :size="24") mdi-arrow-left
            v-col.ml-3
              .text-2xl.font-semibold.neutral700--text {{ stockTake.name }}
            v-col.shrink
              y-button(label="Share" outlined size="sm" button-class="px-3" prepend-icon="$yzi-upload-01" icon-size="18" @click="openShareDialog = true")
          div.d-flex.align-center.justify-space-between.mt-6
            div
              div.d-flex.align-center
                v-icon(color="neutral700" size="22") $yzi-users-solid-03
                div.text-sm.neutral700--text.ml-3 {{ stockTake.member.name }}
            div
              div.d-flex.align-center
                v-icon.mb-1(color="neutral700" size="22") $yzi-calendar-solid
                div.text-sm.neutral700--text.font-semibold.ml-3 Start date:
                div.text-sm.neutral700--text.ml-1 {{ stockTake.created | humanizeDate }}
            div
              div.d-flex.align-center
                v-icon.mb-1(color="neutral700" size="22") $yzi-clock-check-solid
                div.text-sm.neutral700--text.font-semibold.ml-3 Start time:
                div.text-sm.neutral700--text.ml-1 {{ stockTake.created | displayTime2 }}
      
      v-row.mt-6(no-gutters)
        v-col(cols="9")
          v-progress-linear(v-if="isFetchingLocations" width="2" rounded color="primary" indeterminate)
          v-tabs(v-model="locationTab" color="basic700" height="44" @change="updateTab(locationTab)")
            template(v-for="location in locations")
              v-tab.text-sm.font-normal.text-none(active-class="font-semibold") {{ location.name }}

        v-col(cols="3")
          .d-flex.align-center
            v-spacer
            v-btn(@click="clickSearch" icon color="neutral500")
              v-icon(size="20") $yzi-search-sm
            v-text-field(v-if="showSearchField" v-model="searchProducts" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
      v-divider

      v-row.mt-6(no-gutters align="center")
        v-col(cols="6")
          v-row
            v-col
              div.pa-2.clickable(:style="status === 'all' ? activeBorder : inactiveBorder" @click="updateStatusFilter('all')")
                div.text-md.neutral700--text All
                v-progress-circular.mt-3.mb-1(v-if="isFetchingStatus" :width="2" :size="20" color="primary" indeterminate)
                div.text-lg.font-medium.neutral700--text.mt-2(v-else) {{ allCount }}
            v-col
              div.pa-2.clickable(:style="status === 'pending' ? activeBorder : inactiveBorder" @click="updateStatusFilter('pending')")
                div.text-md.neutral700--text Pending
                v-progress-circular.mt-3.mb-1(v-if="isFetchingStatus" :width="2" :size="20" color="primary" indeterminate)
                div.text-lg.font-medium.neutral700--text.mt-2(v-else) {{ pendingCount }}
            v-col
              div.pa-2.clickable(:style="status === 'counted' ? activeBorder : inactiveBorder" @click="updateStatusFilter('counted')")
                div.text-md.neutral700--text Counted
                v-progress-circular.mt-3.mb-1(v-if="isFetchingStatus" :width="2" :size="20" color="primary" indeterminate)
                div.text-lg.font-medium.neutral700--text.mt-2(v-else) {{ countedCount }}
        
      .data-table
        v-data-table.mt-sm-4.pb-6(:headers="headers" :items="products" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetchingProducts" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }")
          //- No data
          template(v-slot:no-data)
            .mt-10(v-if="status === 'pending'")
              img.mx-auto(:src="require('@/assets/images/stocktake_counted.png')" width="100")
              .mt-2.text-sm.font-semibold.neutral700--text Good job!
              .mt-2.text-sm.neutral700--text You’ve counted all the item
          //- item
          template(v-slot:item.name="{ item }")
            .text-sm.font-medium.neutral700--text {{ item.name }}
          //- uom
          template(v-slot:item.uom="{ item }")
            .text-sm.neutral700--text(v-if="getStockUnit(item)") {{ getStockUnit(item) }}
            .text-sm.neutral700--text(v-else) -
          //- current stock
          template(v-slot:item.inventory_qty="{ item }")
            .text-sm.font-medium.success500--text {{ item.inventory_qty }}
          //- actual stock
          template(v-slot:item.actual_stock="{ item }")
            .text-sm.font-medium.info500--text {{ checkActualCount(item) }}
          //- stock difference
          template(v-slot:item.stock_difference="{ item }")
            .text-sm.font-semibold.neutral700--text(v-if="checkStockDiff(item) !== null") {{ checkStockDiff(item) == 0 ? 'Matched' : checkStockDiff(item) }}
          //- actions
          template(v-slot:item.actions="{ item, index }")
            template(v-if="checkStockDiff(item) === null")
              v-row(dense)
                v-col
                  y-button.my-3(label="New count" outlined size="sm" block @click="openNewCount(item)")
                v-col
                  y-button.my-3(label="Matched" outlined size="sm" block @click="matchingCount(item)")
            template(v-else)
              v-row(dense)
                v-col
                  y-button.my-3(label="Remove" color="neutral300" text-color="danger500" size="sm" block @click="openRemoveCount(item)")
                v-col
                  y-button.my-3(label="Edit" outlined size="sm" block @click="openNewCount(item)")

        div.d-flex.align-center(v-if="totalCount > pageSize")
          v-spacer
          yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")
        
        div.py-3

      v-footer.white(v-if="stockTake.member.id === member.id" app inset padless elevation="3")
        v-container.px-8.py-2(fluid)
          div.d-flex.align-center
            v-spacer
            y-button.mr-4(label="Close" underline color="neutral700" size="md" button-class="px-0" @click="openRevertCount")
            y-button(label="Finish counting" color="neutral700" dark :loading="isLoading" @click="openFinishCountDialog = true")
  
  .dialogs
    share-stock-take-dialog(v-if="openShareDialog" :open.sync="openShareDialog" :stocktake="stockTake")
    new-count-dialog(v-if="openNewCountDialog" :open.sync="openNewCountDialog" :product="selectedProduct" :stocktake-id="id" :prefillCount="checkActualCount(selectedProduct) || selectedProduct.inventory_qty" :changed-products.sync="changedProducts" @closed="closedDialog")
    remove-count-dialog(v-if="openRemoveCountDialog" :open.sync="openRemoveCountDialog" :product="selectedProduct" :stocktake-id="id" :changed-products.sync="changedProducts" @closed="closedDialog")
    revert-count-dialog(v-if="openRevertCountDialog" :open.sync="openRevertCountDialog" :stocktake-id="id" :ori-products="oriProducts" @back="closeStockTake")
    finish-count-dialog(v-if="openFinishCountDialog" :open.sync="openFinishCountDialog" @finish="saveData")

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import ShareStockTakeDialog from '@/components/clinic/inventory/stocktake/ShareStockTakeDialog.vue'
import NewCountDialog from '@/components/clinic/inventory/stocktake/NewCountDialog.vue'
import RemoveCountDialog from '@/components/clinic/inventory/stocktake/RemoveCountDialog.vue'
import RevertCountDialog from '@/components/clinic/inventory/stocktake/RevertCountDialog.vue'
import FinishCountDialog from '@/components/clinic/inventory/stocktake/FinishCountDialog.vue'

export default {
  components: { ShareStockTakeDialog, NewCountDialog, RemoveCountDialog, RevertCountDialog, FinishCountDialog },
  props: ['id', 'savePage', 'saveTab', 'saveSearch', 'saveFilters', 'listPage', 'summaryPage', 'clinicSlug'],
  provide () {
    return { stockTakeSlug: () => this.slug }
  },
  data () {
    return {
      isLoading: false,
      isFetching: false,
      isFetchingLocations: false,
      isFetchingProducts: false,
      isFetchingStatus: false,
      showSearchField: false,
      openShareDialog: false,
      openNewCountDialog: false,
      openRemoveCountDialog: false,
      openRevertCountDialog: false,
      openFinishCountDialog: false,
      locationTab: 0,
      pageSize: 20,
      totalCount: 0,
      allCount: 0,
      pendingCount: 0,
      countedCount: 0,
      currentPage: 1,
      status: 'all',
      searchProducts: null,
      selectedProduct: null,
      stockTake: null,
      products: [],
      oriProducts: [],
      changedProducts: [],
      userLocations: [],
      activeBorder: {
        border: '2px solid var(--v-neutral700)',
        borderRadius: '8px',
        padding: '16px'
      },
      inactiveBorder: {
        border: '2px solid var(--v-neutral300)',
        borderRadius: '8px',
        padding: '16px'
      },
    }
  },
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({ company: 'getCompany' }),
    slug () {
      return this.clinicSlug || this.company.slug
    },
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    locations () {
      return [{ name: 'All', isDefault: true }, ...this.userLocations, { name: 'Unassigned', isUnassigned: true, isDefault: true }]
    },
    headers () {
      let items = [
        { text: 'Item', value: 'name', class: 'text-table-header' },
        { text: 'UOM', value: 'uom', class: 'text-table-header' },
        { text: 'Current stock', value: 'inventory_qty', class: 'text-table-header' },
        { text: 'Actual stock', value: 'actual_stock', class: 'text-table-header' },
        { text: 'Stock difference', value: 'stock_difference', class: 'text-table-header' },
      ]
      if (this.stockTake && this.stockTake.member.id === this.member.id) {
        items.push({ text: '', value: 'actions', class: 'text-table-header' },)
      }
      return items
    } 
  },
  watch: {
    pageSize () {
      this.currentPage = 1
      this.fetchProducts()
    },
  },
  mounted () {
    this.fetchStockTake()
    this.fetchLocations()
    this.fetchProducts()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchStockTake () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.slug}/stock_takes/${this.id}`)
        .then(resp => {
          if (resp.data.status === 'finished') {
            this.goToStockTakeSummary()
          }
          this.stockTake = resp.data
          this.oriProducts = JSON.parse(JSON.stringify(resp.data.products))
          this.changedProducts = JSON.parse(JSON.stringify(resp.data.products))
          this.fetchStatus()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchLocations () {
      this.isFetchingLocations = true
      let params = {
        page_size: -1,
        has_active_products: true,
        ordering: 'value'
      }
      this.$axios.get(`/clinics/${this.slug}/inventories/locations`,  { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            let location = resp.data.results.map(m => { return { id: m.id, name: m.value } })
            this.userLocations = location
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingLocations = false
        })
    },
    fetchProducts () {
      this.isFetchingProducts = true
      let params = {
        status: 'published',
        page_size: this.pageSize,
        page: this.currentPage,
        fields: 'id,name,uom,inventory_qty,location,uom_conversion_enabled,uom_conversions'
      }
      if (this.locations[this.locationTab].id) {
        params.location = this.locations[this.locationTab].id
      } else if (this.locations[this.locationTab].isUnassigned) {
        params.has_location = false
      }
      if (this.status === 'pending') {
        params.exclude_ids = this.changedProducts.map(m => m.id).join()
      } else if (this.status === 'counted') {
        if (!this.changedProducts.length) {
          this.products = []
          this.totalCount = 0
          this.isFetchingProducts = false
          return
        }
        params.ids = this.changedProducts.map(m => m.id).join()
      }
      if (this.searchProducts) {
        params.search = this.searchProducts
      }
      this.$axios.get(`/clinics/${this.slug}/inventories`, { params })
        .then(resp => {
          this.products = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingProducts = false
        })
    },
    fetchStatus () {
      this.isFetchingStatus = true
      let params = {
        status: 'published',
        page_size: 1,
        fields: 'id'
      }
      if (this.locations[this.locationTab].id) {
        params.location = this.locations[this.locationTab].id
      } else if (this.locations[this.locationTab].isUnassigned) {
        params.has_location = false
      }
      if (this.searchProducts) {
        params.search = this.searchProducts
      }
      this.$axios.get(`/clinics/${this.slug}/inventories`, { params })
        .then(resp => {
          this.allCount = resp.data.count
          if (!this.changedProducts.length) {
            this.pendingCount = resp.data.count
            this.countedCount = 0
            this.isFetchingStatus = false
          } else {
            params.exclude_ids = this.changedProducts.map(m => m.id).join()
            this.$axios.get(`/clinics/${this.slug}/inventories`, { params })
              .then(resp => {
                this.pendingCount = resp.data.count
                delete params.exclude_ids
                params.ids = this.changedProducts.map(m => m.id).join()
                this.$axios.get(`/clinics/${this.slug}/inventories`, { params })
                  .then(resp => {
                    this.countedCount = resp.data.count
                  })
                  .catch(() => {
                    this.showMessage(['error', 'Error fetching status'])
                  })
                  .finally(() => {
                    this.isFetchingStatus = false
                  })
              })
              .catch(() => {
                this.showMessage(['error', 'Error fetching status'])
                this.isFetchingStatus = false
              })
          }
        })
        .catch(() => {
          this.showMessage(['error', 'Error fetching status'])
          this.isFetchingStatus = false
        })
    },
    updateStatusFilter (status) {
      this.status = status
      this.currentPage = 1
      this.fetchProducts()
    },
    updateTab () {
      this.currentPage = 1
      this.status = 'all'
      this.fetchProducts()
      this.fetchStatus()
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchProducts || this.searchProducts.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchProducts || this.searchProducts.length === 0) {
        this.showSearchField = false
      }
    },
    queryChanged: debounce(function () {
      this.currentPage = 1
      this.fetchProducts()
      this.fetchStatus()
    }, 750),
    pageChanged () {
      this.fetchProducts()
    },
    checkActualCount (product) {
      let count = null
      let diff = this.checkStockDiff(product)
      if (diff !== null) {
        count = product.inventory_qty + diff
      }
      return count
    },
    checkStockDiff (product) {
      let quantity = null
      let findProduct = this.changedProducts.find(f => f.id === product.id)
      if (findProduct){
        quantity = findProduct.change
      }
      return quantity
    },
    openNewCount (product) {
      this.selectedProduct = product
      this.openNewCountDialog = true
    },
    openRemoveCount (product) {
      this.selectedProduct = product
      this.openRemoveCountDialog = true
    },
    openRevertCount () {
      if (this.stockTake && this.stockTake.member.id !== this.member.id) {
        this.closeStockTake()
      }
      this.openRevertCountDialog = true
    },
    matchingCount (item) {
      this.isLoading = true
      let products = [...this.changedProducts]
      products = products.filter(f => f.id !== item.id)
      products.push({ id: item.id, change: 0 })
      this.$axios.patch(`/clinics/${this.slug}/stock_takes/${this.stockTake.id}`, { products: products })
        .then(() => {
          this.changedProducts = [...products]
          this.fetchStatus()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    saveData () {
      this.isLoading = true
      let data = { status: 'finished' }
      const endpoint = `/clinics/${this.slug}/stock_takes/${this.id}`
      this.$axios.patch(endpoint, data)
        .then(resp => {
          let activity = `Finishing ${resp.data.name}`
          this.updateActivityLog(endpoint, data, resp, 'PATCH', activity, this.id )
          this.showMessage(['success', `${resp.data.name} finished`])
          this.goToStockTakeSummary()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closedDialog () {
      this.selectedProduct = null
      this.fetchStatus()
    },
    closeStockTake () {
      if (this.listPage) {
        let params = {
          savePage: this.savePage,
          saveTab: this.saveTab,
          saveSearch: this.saveSearch,
          saveFilters: this.saveFilters
        }
        this.$router.push({ name: this.listPage, params, query: this.$route.query })
      } else {
        window.location.href = 'https://yezza.com'
      }
    },
    goToStockTakeSummary () {
      let params = { 
        id: this.id,
        page: this.page,
        tab: this.tab
      }
      this.$router.push({ name: this.summaryPage, params, query: this.$route.query })
    },
    getStockUnit (item) {
      if (item.uom_conversion_enabled && item.uom_conversions && item.uom_conversions.length) {
        return item.uom_conversions[item.uom_conversions.length - 1].convert_to || ''
      }
      return item.uom || ''
    },
    updateActivityLog (endpoint, payload, response, method, activity, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'stocktake',
        activity: activity,
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .autocmplt {
    .v-input__append-inner {
      margin-top: 12px !important;
    }
  }
}
.empty-box {
  position: relative;
  border-radius: 10px;
  border: var(--v-basic500) dashed 2px;
}
.button-box {
  border-left: solid 1px var(--v-neutral400);
  border-top: solid 1px var(--v-neutral400);
  border-bottom: solid 1px var(--v-neutral400);
  border-radius: 10px 0 0 10px;
  background-color: var(--v-neutral200);
}
</style>